// extracted by mini-css-extract-plugin
export var actionButton = "_fw-0";
export var fileInput = "_fw-2";
export var paperclip = "_fw-1";